import { PrintBasicInfoTableLayout } from "../../../layout";

type Props = {
	guestNameKana: string;
};

export const BasicInfoGuestNameKanaOfPrintComposition = ({ guestNameKana }: Props) => {
	return <PrintBasicInfoTableLayout title="ふりがな" content={guestNameKana} />;
};
